import { render, staticRenderFns } from "./MaintainceGame.vue?vue&type=template&id=788725be&scoped=true&"
import script from "./MaintainceGame.vue?vue&type=script&lang=js&"
export * from "./MaintainceGame.vue?vue&type=script&lang=js&"
import style0 from "./MaintainceGame.vue?vue&type=style&index=0&id=788725be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788725be",
  null
  
)

export default component.exports